<template>
	<div style="border: 1px solid #ccc; text-align: left; width: 100%">
		<Toolbar
			style="border-bottom: 1px solid #ccc"
			:editor="editor"
			:defaultConfig="toolbarConfig"
			:mode="mode"
		/>
		<Editor
			style="height: 220px; overflow-y: hidden; word-break: break-all"
			v-model="html"
			:defaultConfig="editorConfig"
			:mode="mode"
			@onCreated="onCreated"
			:maxLength="50"
			@customPaste="customPaste"
		/>
	</div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import { ElMessage } from "element-plus";
import { DomEditor } from "@wangeditor/editor";
export default {
	components: { Editor, Toolbar },
	props: ["content", "imgUrl", "messageContent"],
	data() {
		return {
			uploadImgUrl: "",
			editor: null,
			html: "",
			toolbarConfig: {
				excludeKeys: [
					"group-video",
					// "insertLink",
					"insertTable",
					"fullScreen",
					"todo",
					"codeBlock",
					"insertImage",
					"emotion",
					"group-image",
				],
			},
			editorConfig: {
				maxLength: 500,
				placeholder: "请输入内容...",
				// autoFocus: true,
				MENU_CONF: {
					onMaxLength: (editor, maxLength) => {
						console.log("字數超過上限");
							ElMessage({
								message: "字數超過上限",
								type: "error",
							});
						},
					uploadImage: {
						customUpload: async (file, insertFn) => {
							let resultUrl = await this.convertToPng(file);
							insertFn(resultUrl);
						},
					},
				},
			},
			mode: "default", // or 'simple'
		};
	},
	methods: {

		customPaste(editor, event, callback) {
			let text = event.clipboardData.getData("text/plain"); // 获取粘贴的纯文本
			if (text.length > 500) {
				text = text.substring(0, 500);
			}
			if(this.html.length<500){
				editor.insertText(text);
			}
			// 自定义插入内容


			// 返回 false ，阻止默认粘贴行为
			event.preventDefault();
			callback(false); // 返回值（注意，vue 事件的返回值，不能用 return）
		},

		onCreated(editor) {
			this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
			// 查看工具栏默认配置
			// this.$nextTick(() => {
			// 	const toolbar =DomEditor.getToolbar(editor);
			// const curToolbarConfig=toolbar.getConfig();
			// console.log(curToolbarConfig.toolbarKeys);
			// });
		},

		convertToPng(file) {
			return new Promise((resolve, reject) => {
				if (!this.checkImg(file)) return;
				let formData = new FormData();
				formData.append("file", file);
				formData.append("flag", 0);
				this.$http
					.post("/api-cms/upload/image", formData)
					.then((res) => {
						if (res.data.code === 1) {
							resolve(res.data.result.url);
						} else {
							ElMessage({
								message: res.data.message,
								type: "error",
							});
						}
					})
					.catch((err) => {
						reject(err);
						ElMessage({
							message: "上傳失敗",
							type: "error",
						});
					});
			});
		},

		checkImg(file) {
			let type = true;
			let fileType = file.type;
			let arr = ["image/png", "image/jpg", "image/jpeg"];
			if (!arr.includes(fileType)) {
				ElMessage({
					message: "上傳照片只能是jpg或者png格式",
					type: "error",
				});
				type = false;
			}

			return type;
		},
		getText(str) {
			return str
				.replace(/<[^<p>]+>/g, "") // 将所有<p>标签 replace ''
				.replace(/<[</p>$]+>/g, "") // 将所有</p>标签 replace ''
				.replace(/&nbsp;/gi, "") // 将所有 空格 replace ''
				.replace(/<[^<br/>]+>/g, ""); // 将所有 换行符 replace ''
		},
		isNull(str) {
			if (str == "") return true;
			var regu = "^[ ]+$";
			var re = new RegExp(regu);
			return re.test(str);
		},
	},
	mounted() {
		setTimeout(() => {
			this.html = this.content;
		}, 500);
	},
	beforeDestroy() {
		const editor = this.editor;
		if (editor == null) return;
		editor.destroy(); // 组件销毁时，及时销毁编辑器
	},

	watch: {
		html(val) {
			let text = this.getText(val);
			if (val.trim().length < 1 || this.isNull(text)) {
				this.html = "";
				// return;
			}
			// console.log(val);
			this.messageContent(val);
		},
		content(val) {
			this.html = val;
			// console.log(this.html);
			if (!val) {
				this.html = "";
			}
		},
	},
};
</script>

<style>
.w-e-full-screen-container {
	z-index: 999;
}
.w-e-modal {
	position: fixed;
	left: 50% !important;
	top: 50% !important;
	height: 230px !important;
	margin-left: -150px;
	margin-top: -100px;
}
</style>
<!-- <style src="@wangeditor/editor/dist/css/style.css"></style> -->
